import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const stop = body => body.style.overflow = "";
const move = body => body.style.overflow = ""; //出现滚动条
export default {
  name: "popFail",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme"])
  },
  props: {
    show: null,
    coinRef: null,
    //金币动画终点dom
    selectRow: null //{value, unit, type} value: 值 仅UI显示  unit: 单位 仅UI显示 type:类型 tapcoins|usdt|ton
  },

  watch: {
    show(bool) {
      this.$nextTick(() => {
        const body = document.querySelector("body");
        const pop = document.getElementById("pop");
        if (bool) {
          this.isPopResultAnim = true;
          // stop(body);
        } else {
          this.isPopResultAnim = false;
          move(body);
        }
        if (pop.append) {
          pop.append(this.$el);
        } else {
          pop.appendChild(this.$el);
        }
      });
    }
  },
  data() {
    return {
      isPopResultAnim: true
    };
  },
  methods: {
    onAccept() {
      this.isPopResultAnim = false;
      if (this.selectRow.value > 0) {
        if (!this.coinRef) {
          this.$emit("accept");
          this.showGetReward(this.selectRow.type);
        } else {
          this.coinAnimFn(this.selectRow.type);
        }
      } else {
        this.$emit("accept");
        this.$emit('update:show', false);
      }
    },
    //金币位移动画
    coinAnimFn(type) {
      let radius = 80;
      let numCoins = 5;
      let count = 0;
      let src = require(`@images/${this.theme}/new/${this.selectRow.currency}.png`);
      this.$nextTick(() => {
        const coinContainer = this.$refs.resultCoinCoincotainerRef;
        console.log("coinContainer", coinContainer);
        coinContainer.innerHTML = "";
        let coins = [];
        for (let i = 0; i < numCoins; i++) {
          let coin = document.createElement("img");
          coin.src = src;
          coin.classList.add("luckyCoinx");
          let angle = Math.random() * 2 * Math.PI;
          let r = Math.sqrt(Math.random()) * radius;
          let x = radius + r * Math.cos(angle) - 25;
          let y = radius + r * Math.sin(angle) - 25;
          coin.style.left = "50%";
          coin.style.top = "50%";
          coinContainer.appendChild(coin);
          coins.push({
            element: coin,
            finalX: x,
            finalY: y
          });
        }
        void coinContainer.offsetWidth;
        coins.forEach((coin, index) => {
          coin.element.style.animation = `moveToPosition 500s ease forwards`;
          coin.element.style.left = `${coin.finalX}px`;
          coin.element.style.top = `${coin.finalY}px`;
        });
        setTimeout(() => {
          let endButton = this.coinRef;
          let endButtonRect = endButton.getBoundingClientRect();
          let containerRect = coinContainer.getBoundingClientRect();
          let endX = endButtonRect.left - containerRect.left;
          let endY = endButtonRect.top - containerRect.top;
          coins.forEach((coin, index) => {
            setTimeout(() => {
              coin.element.style.left = `${endX}px`;
              coin.element.style.top = `${endY}px`;
              coin.element.addEventListener("transitionend", () => {
                endButton.classList.add("luckyShake");
                setTimeout(() => {
                  endButton.classList.remove("luckyShake");
                }, 10);
              });
              if (index === coins.length - 1) {
                coin.element.addEventListener("transitionend", () => {
                  count++;
                  coinContainer.innerHTML = "";
                  this.$emit("update:show", false);
                  if (count == 1) this.$emit("accept");
                });
              }
            }, index * 25);
          });
        }, 500);
      });
    },
    showGetReward(type) {
      let image = require(`@images/${this.theme}/lucky/lucky-result-coin-${this.selectRow.type}.png`);
      this.$nextTick(() => {
        coinAnimFn({
          containerRef: document.getElementById("destoryCoinContainerRef"),
          ref: document.getElementById("coinRef"),
          img: image,
          radius: 300,
          numCoins: 50,
          callback: () => {}
        }, this);
      });
    }
  }
};